module.exports = __webpack_public_path__ + "static/media/KaTeX_AMS-Regular.3d8245dc.woff2";